import styled from 'styled-components';

interface tableResponsiveProps {
	margin?: string;
	projectDetailsConScroll?: boolean;
	tradeDetailsConScroll?: boolean;
	manageUserScroll?: boolean;
}
const TableResponsive = styled.div<tableResponsiveProps>`
	display: block;
	width: 100%;
	overflow-x: none;
	-webkit-overflow-scrolling: touch;
	margin: ${({ margin }) => margin};
	${({ projectDetailsConScroll }) =>
		projectDetailsConScroll &&
		`max-height: calc(100vh - 415px);
		overflow: auto;
		@media screen and (max-width:640px){
            height:auto;
            table{
                width:150vw;
            }
		}
	`}
	${({ tradeDetailsConScroll }) =>
		tradeDetailsConScroll &&
		`max-height: calc(100vh - 320px);
		overflow: auto;
		padding-bottom:10px;
		@media screen and (max-width:640px){
            height:auto;
            table{
                width:150vw;
            }
		}
	`};
	${({ manageUserScroll }) =>
		manageUserScroll &&
		`max-height: calc(100vh - 243px);
		overflow: auto;
		padding-bottom:10px;
		@media screen and (max-width:640px){
            height:auto;
            table{
                width:150vw;
            }
		}
	`}
`;

export default TableResponsive;
